import { TicketWorklistView } from '../../../services/TicketService';

const INACTIVE_STATUSES = ['CLOSED', 'CANCELLED', 'RESOLVED', 'COMPLETED'] as const;

/** Filter out closed/cancelled/resolved/completed tickets to show only active work */
export const filterActiveTickets = (tickets: TicketWorklistView[]): TicketWorklistView[] =>
  tickets.filter(t => !INACTIVE_STATUSES.includes(t.status?.toUpperCase() as typeof INACTIVE_STATUSES[number]));

/** Shorthand: count of active tickets in the list */
export const countActiveTickets = (tickets: TicketWorklistView[]): number =>
  filterActiveTickets(tickets).length;
